import { render, staticRenderFns } from "./logistics-edit-tab.vue?vue&type=template&id=5b7a1ed1&scoped=true"
import script from "./logistics-edit-tab.vue?vue&type=script&lang=js"
export * from "./logistics-edit-tab.vue?vue&type=script&lang=js"
import style0 from "./logistics-edit-tab.vue?vue&type=style&index=0&id=5b7a1ed1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7a1ed1",
  null
  
)

export default component.exports